module.exports = "<button class=\"btn btn-danger\" [disabled]=\"disabled\"><fa name=\"trash\"></fa></button>\n"